import { render, staticRenderFns } from "./ProductShippingConfig.vue?vue&type=template&id=66e5ebfa&scoped=true&"
import script from "./ProductShippingConfig.vue?vue&type=script&lang=js&"
export * from "./ProductShippingConfig.vue?vue&type=script&lang=js&"
import style0 from "./ProductShippingConfig.vue?vue&type=style&index=0&id=66e5ebfa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e5ebfa",
  null
  
)

export default component.exports